import Header from 'header'
import TabBar from './TabBar'
import Tab from './Tabs'
import WorkspaceInfo from './WorkspaceInfo'
import { View } from './view'

import { useGetWorkspaceById } from '~workspace/hooks/useGetWorkspaceById'

const Workspace = (props) => {
  const { workspaceId } = props

  const { loading, error } = useGetWorkspaceById(workspaceId)

  return (
    <View
      error={error}
      loading={loading}
      slots={{
        Header,
        WorkspaceInfo,
        TabBar,
        Tab
      }}
    />
  )
}

export { Workspace }
export default Workspace
